import Http from '../../../../network/Http'

export default class NatPasswordRepo {
    http: Http;

    constructor(http: Http) {
        this.http = http
    }

    // パスワード更新(トークン)
    async putPasswordToken(token: string, password: string): Promise<void> {
        return await this.http.put('/api/resident/password/token', {token: token, password: password})
    }

    // パスワード更新(ログイン済)
    async putPasswordAuthed(password: string): Promise<void> {
        return await this.http.put('/api/resident/password/authed', {password: password})
    }
}
